<template>
  <div class="point-marker">
    <img alt="point-marker" src="@/assets/images/point/marker-no-shadow.svg" />

    <div v-if="showHomeIcon" class="point-marker__warehouse" :style="{ backgroundColor: color }">
      <i class="icon-fill_home" />
    </div>
    <div v-else class="point-marker__numbering" :style="{ backgroundColor: color }">
      <span>{{ number }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#000000',
    },
    number: {
      type: Number,
      default: 1,
    },
    point: {
      type: Object,
      default: () => {},
    },
    isRoSwatActive: {
      type: Boolean,
      default: false,
    },
    isStartPoint: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showHomeIcon() {
      if (this.isRoSwatActive) {
        return this.isStartPoint
      }

      return this.point.service_time === 'PT0S'
    },
  },
}
</script>

<style lang="scss" scoped>
.point-marker {
  position: relative;
  text-align: center;

  img {
    width: 100%;
  }

  &__numbering {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;

    span {
      position: absolute;
      top: 8px;
      left: 0;
      right: 0;
      margin: 0 auto;
      color: $white;
      font-size: 16px;
      font-weight: 600;
    }
  }

  &__warehouse {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;

    i {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 20px;
      color: $white;

      &:before {
        color: $white;
      }
    }
  }
}
</style>
